'use client';

import { useMemo, useState } from 'react';
import { IBranchPreview } from 'app/interfaces/branches';
import Map from 'app/components/common/Map';
import FooterMapSlider from './Slider';
import { IMapPlace } from 'app/interfaces/map';

export default function FooterMap({
  branches
}: {
  branches: IBranchPreview[];
}) {
  const [activeItemId, setActiveItemId] = useState<string | number | null>(
    null
  );

  const places = useMemo<IMapPlace[]>(() => {
    return branches
      .filter(branch => branch.coordinates !== null)
      .map(branch => {
        return {
          id: branch.id,
          title: branch.name,
          coordinates: branch.coordinates
        };
      }) as IMapPlace[];
  }, [branches]);

  const onMouseEnter = (id: number | string) => {
    setActiveItemId(id);
  };

  const onMouseLeave = (id: number | string) => {
    setActiveItemId(null);
  };

  return (
    <div className="relative overflow-hidden h-60 md:h-[320px] md:pb-0 rounded isolate">
      <div className="absolute bottom-10 right-0 w-full">
        <FooterMapSlider
          branches={branches}
          activeItemId={activeItemId}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </div>
      <Map
        places={places}
        activePlaceId={activeItemId}
        onMarkerMouseEnter={onMouseEnter}
        onMarkerMouseLeave={onMouseLeave}
      />
    </div>
  );
}
